import moment from 'moment';
import { default as Endpoint } from '../../api/Endpoint';
import * as Constants from '../constants';

const DEMO_DATA = require('../../demo.json');
const DEMO_DATA_WEEK = require('../../demo-week.json');
const DEMO_DATA_MONTH = require('../../demo-month.json');
const DEMO_DATA_WEATHER = require('../../demo-weather.json');
const DEMO_DATA_WEATHER_WEEK = require('../../demo-weather-week.json');
const DEMO_DATA_WEATHER_MONTH = require('../../demo-weather-month.json');
const DEMO_DATA_TEMP = require('../../demo-temp.json');
const DEMO_DATA_TEMP_WEEK = require('../../demo-temp-week.json');
const DEMO_DATA_TEMP_MONTH = require('../../demo-temp-month.json');
const DEMO_DATA_OUTDOOR = require('../../demo-outdoor.json');
const DEMO_DATA_OUTDOOR_WEEK = require('../../demo-outdoor-week.json');
const DEMO_DATA_OUTDOOR_MONTH = require('../../demo-outdoor-month.json');

export function requestJobs() {
  return {
    type: Constants.REQUEST_JOBS
  };
}
export function receiveJobs(json, error) {
  return {
    type: Constants.RECEIVE_JOBS,
    data: json,
    error
  };
}

export function requestJobDetails(job) {
  return () => ({
    type: Constants.REQUEST_JOB_DETAILS,
    id: job.id
  });
}
export function receiveJobDetails(job) {
  return (json, error) => ({
    type: Constants.RECEIVE_JOB_DETAILS,
    data: json,
    id: job.id,
    error
  });
}

export function requestPerformance(url = null) {
  return () => ({
    type: Constants.REQUEST_PERFORMANCE,
    url
  });
}
export function receivePerformance(url = null) {
  return (json, error) => ({
    type: Constants.RECEIVE_PERFORMANCE,
    url,
    data: json,
    error
  });
}

export function modifyAnalyticsFilter(filter) {
  return {
    type: Constants.MODIFY_ANALYTICS_FILTER,
    filter
  };
}

export function modifyAttributeFilters(attributeFilters) {
  return {
    type: Constants.MODIFY_ATTRIBUTE_FILTERS,
    attributeFilters
  };
}

export function modifyAttributeChart(check) {
  return {
    type: Constants.MODIFY_ATTRIBUTE_CHART,
    check
  };
}

export function getJobs(options = {}) {
  const path = 'ecs/api/job?expand=no';
  return new Endpoint(path, requestJobs, receiveJobs)
    .withOptions(options)
    .call();
}

export function getJobDetails(job, options = {}) {
  const path = `ecs/api/job/${job.id}`;
  return new Endpoint(path, requestJobDetails(job), receiveJobDetails(job))
    .withOptions(options)
    .call();
}

export function urlForFilter(filter, attributeFilters = {}) {
  let url;
  switch (filter.filterBy) {
    case 'assetClass':
      if (filter.filter) {
        url = `ecs/api/class/${filter.filter}/performance`;
      }
      break;
    case 'jobId':
      if (filter.block && filter.filter && filter.filter.id) {
        url = `ecs/api/job/${filter.filter.id}/performance/${filter.block.block_id}`;
      }
      break;
    case 'assetAttribute':
      if (filter.filter) {
        if (filter.filter === 'ect_tags') {
          url = `ecs/api/tag/performance`;
        } else {
          url = `ecs/api/asset_attributes/${filter.filter}/performance`;
        }
      }
      break;
    default:
      break;
  }
  if (url) {
    if (filter.startDate && filter.endDate) {
      const params = {
        v: '2',
        from: encodeURIComponent(
          moment(filter.startDate)
            .startOf('day')
            .toISOString(true)
        ),
        to: encodeURIComponent(
          moment(filter.endDate)
            .endOf('day')
            .toISOString(true)
        ),
        top: filter.top === undefined ? 0 : filter.top
      };

      if (
        attributeFilters.byAttribute &&
        attributeFilters.byValue &&
        attributeFilters.byValue !== 'none'
      ) {
        params.attribute = encodeURIComponent(attributeFilters.byAttribute);
        params.attribute_value = encodeURIComponent(attributeFilters.byValue);
      }
      let qs = Object.keys(params)
        .map(key => `${key}=${params[key]}`)
        .join('&');

      return `${url}?${qs}`;
    }
  }
  return undefined;
}

function demoData(filter) {
  const date = moment(filter.startDate)
    .startOf('day')
    .toISOString();
  const dateRange = filter.endDate.getTime() - filter.startDate.getTime();
  let data;
  if (dateRange > 1123200000) {
    if (filter.filterBy === 'assetAttribute') {
      if (filter.filter === 'Temperature Range') {
        data = DEMO_DATA_TEMP_MONTH;
      } else if (filter.filter === 'Outdoor Activities') {
        data = DEMO_DATA_OUTDOOR_MONTH;
      }
      return { ...data };
    } else {
      if (filter.filter.includes('Weather')) {
        data = DEMO_DATA_WEATHER_MONTH;
      } else {
        data = DEMO_DATA_MONTH;
      }
    }
  } else if (dateRange > 0) {
    if (filter.filterBy === 'assetAttribute') {
      if (filter.filter === 'Temperature Range') {
        data = DEMO_DATA_TEMP_WEEK;
      } else if (filter.filter === 'Outdoor Activities') {
        data = DEMO_DATA_OUTDOOR_WEEK;
      }
      return { ...data };
    } else {
      if (filter.filter.includes('Weather')) {
        data = DEMO_DATA_WEATHER_WEEK;
      } else {
        data = DEMO_DATA_WEEK;
      }
    }
  } else {
    if (filter.filterBy === 'assetAttribute') {
      if (filter.filter === 'Temperature Range') {
        data = DEMO_DATA_TEMP;
      } else if (filter.filter === 'Outdoor Activities') {
        data = DEMO_DATA_OUTDOOR;
      }
      return { ...data };
    } else {
      if (filter.filter.includes('Weather')) {
        data = DEMO_DATA_WEATHER;
      } else {
        data = DEMO_DATA;
      }
    }
    return {
      ...data,
      details: data.details.map(details => ({
        ...details,
        timestamp: date.substring(0, 10) + details.timestamp.substring(10)
      }))
    };
  }

  return {
    ...data,
    details: data.details.map(details => ({
      ...details,
      timestamp: date.substring(0, 8) + details.timestamp.substring(8)
    }))
  };
}

export function getPerformance(filter, attributeFilters, options = {}) {
  const path = urlForFilter(filter, attributeFilters);
  if (path) {
    if (
      options.demo &&
      (filter.filterBy !== 'assetAttribute' ||
        filter.filter === 'Temperature Range' ||
        filter.filter === 'Outdoor Activities')
    ) {
      return dispatch => {
        dispatch(requestPerformance(path)());
        dispatch(receivePerformance(path)(demoData(filter)));
      };
    }

    return new Endpoint(
      path,
      requestPerformance(path),
      receivePerformance(path)
    )
      .withOptions(options)
      .call();
  } else {
    return dispatch => {};
  }
}
